document.addEventListener('DOMContentLoaded', function () {

  function targetClass(targetClass) {
    if (document.querySelectorAll(targetClass).length === 0) {
      return
    }
    const itemsLists = document.querySelectorAll(targetClass)

    itemsLists.forEach(function(list) {

      list.dataset.initialDisplay = window.getComputedStyle(list).display;

    })
  }
  targetClass('.p-taxonomies__itemsList')
  targetClass('.p-purposes__itemsList')
  targetClass('.p-makers__itemsList')


  function slideUp(target, duration = 500) {

    target.dataset.height = `${target.clientHeight}px`
    target.dataset.paddingtop = window.getComputedStyle(target).paddingTop
    target.dataset.paddingbottom = window.getComputedStyle(target).paddingBottom

    target.style.height = `${target.clientHeight}px`
    target.animate(
      [
        {
          height: '0',
          paddingTop: '0',
          paddingBottom: '0',
          opacity: '0'
        }
      ],
      {
        duration: duration,
        fill: 'forwards', // アニメーション後の状態を継続,
        easing: 'ease-in-out'
      }
    )
    .onfinish = () => {
      target.style.display = 'none'
    }
  }

  function slideDown(target, duration = 500) {

    // 初期表示スタイルが保存されている場合はそれを適用、そうでなければ 'block' を使用
    const initialDisplay = target.dataset.initialDisplay || 'block'
    target.style.display = initialDisplay;

    if (!target.dataset.height) {
      target.dataset.height = `${target.clientHeight}px`
      target.dataset.paddingtop = window.getComputedStyle(target).paddingTop
      target.dataset.paddingbottom = window.getComputedStyle(target).paddingBottom
    }

    target.animate(
      [
        {
          height: '0',
          paddingTop: '0',
          paddingBottom: '0',
          opacity: '0'
        },
        {
          height: target.dataset.height,
          paddingTop: target.dataset.paddingtop,
          paddingBottom: target.dataset.paddingbottom,
          opacity: '1'
        }
      ],
      {
        duration: duration,
        fill: 'forwards', // アニメーション後の状態を継続,
        easing: 'ease-in-out'
      }
    )
  }

  function slideToggle(target, duration = 500) {

    if (target.style.display === 'none' || window.getComputedStyle(target).display === 'none') {
      slideDown(target, duration)
    } else {
        slideUp(target, duration)
    }
  }

  function setAccordionBtn(classSelectorBtn, isNext) {
    if (document.querySelector(classSelectorBtn)) {

      document.querySelectorAll(classSelectorBtn).forEach(btn => {
        // btnの親要素の次の兄弟要素を取得
        let target = btn.parentElement.nextElementSibling;
        if( isNext ) { //第二引数にtrueが入ったら,実行される
          target = btn.nextElementSibling;
        }
        slideUp(target, 0)
        console.log(target)

          btn.addEventListener('click', () => {
              if (target) {
                  target.classList.toggle('active')
                slideToggle(target)
                  btn.classList.toggle('active')
              }
          })
      })
    }
  }

  setAccordionBtn('.l-footer .js-accordion .item-flex',true)
  setAccordionBtn('.p-taxonomies__taxonomiesListItemsLabrl',true)
  setAccordionBtn('.p-purposes__taxonomiesListItemsLabrl',true)
  setAccordionBtn('.p-makers__taxonomiesListItemsLabrl',true)
})


